import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  PageCategoryCO,
  PageCategoryType,
  PageContentCO
} from 'src/app/shared/models/ApiModels';

import { ApiUrls } from 'src/app/shared/const/Api-urls';

@Component({
  selector: 'app-admission-update',
  templateUrl: './admission-update.component.html',
  styleUrls: ['./admission-update.component.scss']
})
export class AdmissionUpdateComponent implements OnChanges {

  @Input() categoryMap!: Map<PageCategoryType, PageCategoryCO>;

  // ================= CMS CONTENTS =================

  admissionDescription?: PageContentCO;

  admissionRedirectUrl?: PageContentCO;

  admissionPostedDate?: PageContentCO;

  admissionImage = '';

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['categoryMap']) {
      this.buildAdmissionUpdate();
    }
  }

  private buildAdmissionUpdate(): void {

    const admission = this.categoryMap?.get(
      PageCategoryType.ADMISSION_UPDATE
    );

    // ================= CONTENTS =================

    this.admissionDescription =
      admission?.content?.find(item => item.msgOrder === 1);

    this.admissionRedirectUrl =
      admission?.content?.find(item => item.msgOrder === 2);

    this.admissionPostedDate =
      admission?.content?.find(item => item.msgOrder === 3);

    // ================= IMAGE =================

    this.admissionImage =
      admission?.image?.[0]
        ? this.getFileUrl(admission.image[0].file.fileUUID)
        : '';

    console.log(admission)
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }

  // ================= CTA =================

  viewUpdate(): void {

    const link = this.admissionRedirectUrl?.content;

    if (!link) return;

    window.location.href = link;
  }
}